import { Component, OnInit,EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() isExpanded: boolean = false;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  handleSidebarToggle = () => this.toggleSidebar.emit(!this.isExpanded);
  constructor() { }
  public sidebarShow: boolean = true;
  status: boolean = true;
  //Sidebar opne
  clickEvent(){
      this.status = true;       
  }
  //Sidebar close
  clickEvent2()
  {
    this.status = false; 
  }
  // add_agent(){
  //   this.router.navigate(['/dash/sidebar/agent_add'])
  // }

  ngOnInit(): void {
  }

}
